$( document ).ready(function() {
    
    var $slider = $('.blog__posts');
    var $progressBar = $('.progress');
    var $progressBarLabel = $( '.slider__label' );
  
  $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
    
    $progressBar
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );
    
    $progressBarLabel.text( calc + '% completed' );
  });
  
  $slider.slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 400
  }); 
}); 


   // $(document).ready(function () {
   //          $("body .destroy-slide").slider("destroy");
   //      });
   //  });

$( document ).ready(function() {

setTimeout(function(){
  var opt1 = $('#swatch-option1').attr('option-name');
  if(opt1 == 'Size'){
        $('<span class="extra_small_font">Please select the size to continue</span>').insertBefore($('#swatch-option1'))
  }

  var opt2 = $('#swatch-option2').attr('option-name');
  if(opt2 == 'Size'){
    $('<span class="extra_small_font">Please select the size to continue</span>').insertBefore($('#swatch-option2'))
  }

  $("#Details-HeaderMenu-4 .header__menu-item span").text(function () {
      return $(this).text().replace("1", ""); 
  });

  
 
  
 $("#Details-HeaderMenu-6 .header__menu-item span").text(function () {
      return $(this).text().replace("1", ""); 
  });

  /* $("#Details-menu-drawer-menu-item-6 .menu-drawer__menu-item").text(function () {
      return $(this).text().replace("1", ""); 
  }); */

  $('.Piercing.Service div span.m-pointer').addClass('hide');

   $("#Details-menu-drawer-menu-item-4 .menu-drawer__menu-item span").text(function () {
      return $(this).text().replace("1", ""); 
  });
    
     $("#Details-menu-drawer-menu-item-6 .menu-drawer__menu-item span").text(function () {
        return $(this).text().replace("1", ""); 
    });  

  
    $(".m-heading .m-active-title").text(function () {
        return $(this).text().replace("1", ""); 
    });  

   
}, 500); 
  
  $('.slider_mobile').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    centerMode: false,
    centerPadding: '20px',
  });

   $('.slider_desktop').slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    dots: true,
    arrows: true,
     centerMode: false,
    centerPadding: '0',

  });

  $('.slider_multicolumn').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    centerMode: false,
    centerPadding: '0',
  });

  $('.collection_mobile_slider.grid--2-col-tablet-down').slick({
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    centerMode: false,
    centerPadding: '10px',
  });


  $('.tollbar-img .sr-1').click(function(){

       $('.tollbar-img span').removeClass('active');
      $(this).parent().removeClass('active');
      $('ul#product-grid').removeClass('grid--4-col-desktop');
      $('ul#product-grid').removeClass('grid--3-col-desktop');
      $('ul#product-grid').addClass('grid--3-col-desktop');
      $(this).parent().addClass('active');
      });
      
  $('.tollbar-img .sr-2').click(function(){
         $('.tollbar-img span').removeClass('active');
        $(this).parent().removeClass('active');
          $('.tollbar-img .sr-2').addClass('active');
         $('ul#product-grid').removeClass('grid--4-col-desktop');
      $('ul#product-grid').removeClass('grid--3-col-desktop');
        $('ul#product-grid').addClass('grid--4-col-desktop');
        $(this).parent().addClass('active');
      });

  $('.tollbar-img.medium-hide .sr-2').click(function(){

       $('.tollbar-img.medium-hide span').removeClass('active');
      $(this).parent().removeClass('active');
      $('ul#product-grid').removeClass('grid--1-col');
      $('ul#product-grid').removeClass('grid--2-col');
      $('ul#product-grid').addClass('grid--1-col');
      $(this).parent().addClass('active');
      });
      
  $('.tollbar-img.medium-hide .sr-1').click(function(){
         $('.tollbar-img.medium-hide span').removeClass('active');
        $(this).parent().removeClass('active');
        
         $('ul#product-grid').removeClass('grid--1-col');
      $('ul#product-grid').removeClass('grid--2-col');
        $('ul#product-grid').addClass('grid--2-col');
        $(this).parent().addClass('active');
      }); 

  $('.desktop_slider').slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    dots: true,
    arrows: true,
     responsive: [
        {
          breakpoint: 1300,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
          }
        },
      {
          breakpoint: 749,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            centerMode: true,
            centerPadding: '0',
          }
        }
      ],
  });

  $('.owl-carousel').slick({
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
     responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ],
  });

  
});
  

document.getElementById("back-top").addEventListener("click",function(e){
  e.preventDefault();
  window.scroll({
    top: 0,
    behavior: 'smooth'
  });
});